const messages = {
  title: "Timeout del gateway",
  description: "Siamo spiacenti per il disagio. Il nostro server non ha ricevuto una risposta in tempo.",
  backHomeButton: "Torna alla dashboard"
}

export default {
  messages
}
